/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-flag': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.75 18.75H2.5V1.25h15l-3.625 5.625L17.5 12.5H3.75v6.25zm0-7.5h11.456l-2.831-4.375L15.206 2.5H3.75v8.75z"/>'
  }
})
